import cloneDeep from 'clone-deep'
import  urlRegex from 'url-regex'

import * as pagesConfig from './../config/pages'

let lastId = 0

export function updateObject(oldObject, newObject) {
	return Object.assign({}, cloneDeep(oldObject), newObject)
}

export function getPageUrl(pageName) {
	return pagesConfig.pages[pageName].to
}

export function generateUniqueId(suffix = 'id') {
	lastId++
	return `${lastId}${suffix}`
}

export function getUrlListfromString(text) {
	return text.trim().match(urlRegex()) || []
}